import Box from '@mui/material/Box';
import { FormattedMessage } from 'react-intl';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import PromotionCampaignBanner from './PromotionCampaignBanner';
import { fromPromotion } from '../../../../store';
import { PromotionPackages } from './PromotionPackages';
import { SingleProductPromotionInfo } from '../../../../models';

export const PromotionSection = (
  { accountId }: { accountId: number },
) => {
  const promotionInfo = useSelector(
    fromPromotion.selectActivePromotion,
  ) as SingleProductPromotionInfo;

  return (
    <Box
      id="package-offering-section"
      boxShadow="0 8px 16px 0 rgba(24, 71, 202, 0.08)"
      mt={2}
    >
      <PromotionCampaignBanner />

      <Box
        id="bundle-offering-title"
        key="bundle-offering-title"
        display="none"
        flexDirection="row"
      >
        <Typography
          component="p"
          ml={theme => theme.spacing(3)}
          color="#4D5369"
          fontWeight={500}
          fontSize={16}
          my={theme => theme.spacing(3)}
        >
          <FormattedMessage
            id="promotion.campaign.subtitle"
            values={{
              key: (
                <Typography component="b" color="#4D5369" fontWeight={700} fontSize={16}>
                  <FormattedMessage id="promotion.campaign.subtitle.key" />
                </Typography>
              ),
              value: (<FormattedMessage id="promotion.campaign.subtitle.value" />),
            }}
          />
        </Typography>
      </Box>

      <PromotionPackages
        accountId={accountId}
        campaignCode={promotionInfo?.campaignCode}
      />
    </Box>
  );
};
